<template>
    <div class="filter_box">
        <div class="filter_row">
            <label v-for="type of chartData.type" :for="type.name" :key="type.name">
                <input type="checkbox" name="" :id="type.name" checked @change="handleChangeType(type)" />
                <span class="check_box"></span>
                <i :class="type.type" :style="`background: ${Array.isArray(type.color) ? type.color[0] : type.color};`"></i>
                <span>{{ type.name }}</span>
            </label>
        </div>
        <div class="filter_row">
            <label v-for="year of chartData.years" :for="year" :key="year">
                <input type="checkbox" name="" :id="year" :value="year" checked @change="handleChangeYear(year)" />
                <span class="check_box"></span>
                <span>{{ year }}</span>
            </label>
        </div>
    </div>
    <canvas class="chart_dom"></canvas>
</template>

<script>
import Chart from 'chart.js/auto';

export default {
    props: {
        data: {
            deafult: {},
        },
    },
    data() {
        return {
            chartData: this.data,
            selectedYear: this.data.years,
        };
    },
    mounted() {
        this.chart = new Chart(document.querySelector('.chart_dom'), {
            data: {
                labels: this.chartData.years,
                grouped: true,
                datasets: this.chartData.type.map((typeData) => {
                    return {
                        label: typeData.name,
                        type: typeData.type,
                        categoryPercentage: 0.65,
                        barPercentage: 0.65,
                        data: typeData.data,
                        borderColor:
                            typeData.type === 'line'
                                ? () => {
                                      if (Array.isArray(typeData.color)) {
                                          const bar_ctx = document.querySelector('.chart_dom').getContext('2d');
                                          const bg = bar_ctx.createLinearGradient(0, 0, 0, 300);
                                          bg.addColorStop(0, typeData.color[0]);
                                          bg.addColorStop(1, typeData.color[1]);
                                          return bg;
                                      } else {
                                          return typeData.color;
                                      }
                                  }
                                : 'transparent',
                        backgroundColor: () => {
                            if (Array.isArray(typeData.color)) {
                                const bar_ctx = document.querySelector('.chart_dom').getContext('2d');
                                const bg = bar_ctx.createLinearGradient(0, 0, 0, 300);
                                bg.addColorStop(0, typeData.color[0]);
                                bg.addColorStop(1, typeData.color[1]);
                                return bg;
                            } else {
                                return typeData.color;
                            }
                        },
                        pointBorderWidth: 3,
                        borderRadius: 4,
                    };
                }),
            },
            options: {
                responsive: true,
                onResize: (chart, { width }) => {
                    if (width < 600) {
                        chart.options.scales.x.ticks.font.size = 10;
                        chart.options.scales.y.ticks.font.size = 10;

                        chart.options.scales.x.ticks.padding = 5;
                        chart.options.scales.y.ticks.padding = 5;

                        chart.options.scales.y.title.display = false;
                        // chart.options.scales.y.title.font.size = 10;
                        // chart.options.scales.y.title.padding = 5;
                    } else {
                        chart.options.scales.x.ticks.font.size = 16;
                        chart.options.scales.y.ticks.font.size = 16;
                        // chart.options.scales.y.title.font.size = 16;

                        chart.options.scales.y.title.display = true;
                    }
                },
                scales: {
                    x: {
                        stacked: this.chartData.stacked,
                        beginAtZero: true,
                        border: {
                            color: '#000',
                        },
                        grid: {
                            color: 'transparent',
                        },
                        ticks: {
                            padding: 20,
                            font: {
                                size: 16,
                                family: 'Pretendard',
                            },
                        },
                    },
                    y: {
                        stacked: this.chartData.stacked,
                        title: {
                            display: true,
                            text: `${this.chartData.unit}`,
                            font: {
                                size: 16,
                                weight: 'bold',
                            },
                        },
                        border: {
                            color: 'transparent',
                        },
                        ticks: {
                            // stepSize: this.chartData.step || 100000,
                            maxTicksLimit: 8,
                            padding: 20,
                            font: {
                                size: 16,
                                family: 'Pretendard',
                            },
                        },
                    },
                },
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        caretSize: 0,
                        padding: 20,
                        boxWidth: 16,
                        boxHeight: 12,
                        boxPadding: 5,
                        backgroundColor: '#fff',
                        borderColor: function ({ tooltip }) {
                            return tooltip.dataPoints[0].dataset.backgroundColor();
                        },
                        borderWidth: 2,
                        titleColor: '#000',
                        titleFont: {
                            size: 16,
                            family: 'Pretendard',
                        },
                        bodyColor: '#333',
                        bodyFont: {
                            size: 16,
                            family: 'Pretendard',
                        },
                        callbacks: {
                            label: (context) => {
                                let label = context.dataset.label || '';

                                if (label) {
                                    label += '  ';
                                }
                                if (context.parsed.y !== null) {
                                    label += `${context.parsed.y.toLocaleString('ko-KR')} ${this.chartData.unit}`;
                                }
                                return label;
                            },
                            labelColor: ({ dataset: { backgroundColor } }) => {
                                return {
                                    borderColor: 'transparent',
                                    backgroundColor: backgroundColor(),
                                    borderWidth: 0,
                                    borderRadius: 2,
                                };
                            },
                        },
                    },
                },
            },
        });

        this.originChartData = this.chart.data.datasets;
    },
    methods: {
        handleChangeType(value) {
            const target = this.chart.data.datasets.find((el) => {
                return el.label === value.name;
            });

            target.hidden = !target.hidden;
            this.chart.update();
        },

        handleChangeYear(year) {
            if (this.selectedYear.indexOf(year) === -1) {
                this.selectedYear.push(year);
            } else {
                this.selectedYear = this.selectedYear.filter((el) => el !== year);
            }
            this.selectedYear.sort();

            this.chart.data.labels = this.data.years.filter((label) => {
                return this.selectedYear.includes(label);
            });

            const selectedYearArr = this.selectedYear.map((el) => {
                return this.data.years.indexOf(el);
            });

            this.chart.data.datasets = [...this.originChartData].map((el) => {
                return { ...el, data: el.data.filter((el, idx) => selectedYearArr.includes(idx)) };
            });

            this.chart.update();
        },
    },
};
</script>

<style scoped lang="scss">
.filter_box {
    border: 1px solid #e5e5e5;
    padding: 0 40px;
    margin-bottom: 80px;

    @media screen and (max-width: 1280px) {
        padding: 0 20px;
    }

    @media screen and (max-width: 768px) {
        padding: 0 10px;
    }

    .filter_row {
        padding: 25px 0;
        border-bottom: 1px solid #e5e5e5;
        display: flex;
        flex-wrap: wrap;
        gap: 80px;

        @media screen and (max-width: 1024px) {
            gap: 40px;
        }

        @media screen and (max-width: 768px) {
            gap: 15px;
            flex-wrap: wrap;
        }

        label {
            flex: 0 0 auto;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            cursor: pointer;

            input[type='checkbox'] {
                display: none;

                &:checked ~ .check_box {
                    position: relative;
                    border-color: var(--orange);

                    &::after {
                        position: absolute;
                        content: '';
                        width: 5px;
                        height: 10px;
                        top: calc(50% - 2.5px);
                        left: 50%;
                        transform: translate(-50%, -50%) rotate(45deg);
                        border-bottom: 2px solid var(--orange);
                        border-right: 2px solid var(--orange);
                    }
                }

                &:checked ~ span {
                    color: #111;
                }

                &:checked ~ i {
                    opacity: 1;
                }
            }

            .check_box {
                display: inline-block;
                width: 20px;
                height: 20px;
                border: 1px solid #e5e5e5;
                margin-right: 10px;
            }

            span {
                color: #ccc;
                @media screen and (max-width: 768px) {
                    font-size: 14px;
                }
            }

            i {
                display: inline-block;
                width: 16px;
                height: 12px;
                margin-right: 5px;
                border-radius: 2px;
                position: relative;
                opacity: 0.3;

                &.line {
                    height: 2px;

                    &::after {
                        position: absolute;
                        content: '';
                        width: 6px;
                        height: 6px;
                        border-radius: 6px;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        background: inherit;
                    }
                }
            }
        }

        &:last-child {
            border-bottom: none;
        }
    }
}
canvas {
    max-height: 400px;
}
</style>
